"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var COMPONENT_CLASS = "block-controls-menu";
var BlockControls = (function (_super) {
    __extends(BlockControls, _super);
    function BlockControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.agreementBlock = undefined;
        _this.handleMoveUp = function () { return __awaiter(_this, void 0, Promise, function () {
            var blockTop, _a, block, blockList, telemetry;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        blockTop = this.blockTop;
                        _a = this.props, block = _a.block, blockList = _a.blockList, telemetry = _a.telemetry;
                        return [4, blockList.moveUp(block)];
                    case 1:
                        _b.sent();
                        telemetry.trackOnly("Block Moved", { block_moved_direction: "up" }, { blockIntercom: true });
                        return [4, this.scrollBlockWithOffset(blockTop)];
                    case 2:
                        _b.sent();
                        return [2];
                }
            });
        }); };
        _this.handleMoveDown = function () { return __awaiter(_this, void 0, Promise, function () {
            var blockTop, _a, block, blockList, telemetry;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        blockTop = this.blockTop;
                        _a = this.props, block = _a.block, blockList = _a.blockList, telemetry = _a.telemetry;
                        return [4, blockList.moveDown(block)];
                    case 1:
                        _b.sent();
                        telemetry.trackOnly("Block Moved", { block_moved_direction: "down" }, { blockIntercom: true });
                        return [4, this.scrollBlockWithOffset(blockTop)];
                    case 2:
                        _b.sent();
                        return [2];
                }
            });
        }); };
        _this.handleClone = function () { return __awaiter(_this, void 0, Promise, function () {
            var _a, block, blockList, blockCreator, blockBottom, blockIndex, insertIndex;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, block = _a.block, blockList = _a.blockList, blockCreator = _a.blockCreator;
                        blockBottom = this.blockBottom;
                        blockIndex = blockList.getIndex(block);
                        insertIndex = blockIndex + 1;
                        return [4, this.scrollBlockWithOffset(blockBottom)];
                    case 1:
                        _b.sent();
                        return [4, blockCreator.cloneAndInsert(block, insertIndex, { insertDelayMs: 500 })];
                    case 2:
                        _b.sent();
                        return [2];
                }
            });
        }); };
        _this.attachCachedAgreement = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, blockList, blockCreator, acceptBlock, agreement;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, blockList = _a.blockList, blockCreator = _a.blockCreator;
                        acceptBlock = blockList.getFirstBlockOfType(BlockTypes_1.BlockType.Accept);
                        if (!(acceptBlock && this.agreementBlock)) return [3, 2];
                        return [4, blockCreator.cloneBlock(this.agreementBlock)];
                    case 1:
                        agreement = _b.sent();
                        acceptBlock.agreement = agreement;
                        _b.label = 2;
                    case 2: return [2];
                }
            });
        }); };
        _this.handleDelete = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, block, blockList, blockCreator, blockFetcher, blockIndex, isAccept, hasAgreement, agreement, error_1, message;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, block = _a.block, blockList = _a.blockList, blockCreator = _a.blockCreator, blockFetcher = _a.blockFetcher;
                        blockIndex = blockList.getIndex(block);
                        isAccept = block.type === BlockTypes_1.BlockType.Accept;
                        hasAgreement = isAccept && !!block.agreement;
                        if (!hasAgreement) return [3, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, blockFetcher.fetchBlockById(block.projectId, block.agreement)];
                    case 2:
                        agreement = _b.sent();
                        if (agreement.type === BlockTypes_1.BlockType.Agreement) {
                            this.agreementBlock = agreement;
                        }
                        return [3, 4];
                    case 3:
                        error_1 = _b.sent();
                        console.error("Error fetching agreement block:", error_1);
                        return [3, 4];
                    case 4:
                        message = hasAgreement
                            ? "Accept block & Agreement deleted"
                            : "".concat(this.getFriendlyBlockType(block.type), " block deleted");
                        this.props.onDeleteBlock(block);
                        this.props.notifyUser.success(react_1.default.createElement(react_1.default.Fragment, null,
                            message,
                            " ",
                            react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4, blockCreator.cloneAndInsert(block, blockIndex, {
                                                    insertDelayMs: 500,
                                                })];
                                            case 1:
                                                _a.sent();
                                                if (this.agreementBlock) {
                                                    this.attachCachedAgreement();
                                                }
                                                return [2];
                                        }
                                    });
                                }); } }, "Undo")));
                        return [2];
                }
            });
        }); };
        _this.getFriendlyBlockType = function (type) {
            if (type === BlockTypes_1.BlockType.Quote) {
                return "Quote";
            }
            if (type === BlockTypes_1.BlockType.Source) {
                return "Embed";
            }
            return type;
        };
        _this.scrollBlockWithOffset = function (offset) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.props.$timeout()];
                    case 1:
                        _a.sent();
                        this.props.projectScrollTo(this.topLevelBlockWrapper, {
                            offset: offset,
                            time: 500,
                            scrollingElement: ".content-container__scroll-container",
                        });
                        return [2];
                }
            });
        }); };
        return _this;
    }
    Object.defineProperty(BlockControls.prototype, "isFirstBlock", {
        get: function () {
            var _a = this.props, block = _a.block, blockList = _a.blockList;
            var index = blockList.getIndex(block);
            return index === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlockControls.prototype, "isLastBlock", {
        get: function () {
            var _a = this.props, block = _a.block, blockList = _a.blockList;
            var length = blockList.getLength();
            var index = blockList.getIndex(block);
            return index === length - 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlockControls.prototype, "isAcceptBlock", {
        get: function () {
            var block = this.props.block;
            return block.type === BlockTypes_1.BlockType.Accept;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlockControls.prototype, "blockTop", {
        get: function () {
            var _a;
            return ((_a = this.topLevelBlockWrapper) === null || _a === void 0 ? void 0 : _a.offset().top) - this.props.navigationHeaderHeight || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlockControls.prototype, "blockBottom", {
        get: function () {
            var _a;
            var blockHeight = (_a = this.topLevelBlockWrapper) === null || _a === void 0 ? void 0 : _a.height();
            var scrollOffsetPadding = 10;
            return blockHeight * -1 + scrollOffsetPadding || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlockControls.prototype, "topLevelBlockWrapper", {
        get: function () {
            var _a, _b, _c;
            var block = this.props.block;
            return (_c = (_b = (_a = block.$ctrl) === null || _a === void 0 ? void 0 : _a.ui) === null || _b === void 0 ? void 0 : _b.blockElement) === null || _c === void 0 ? void 0 : _c.parents(".top-level-block-wrapper");
        },
        enumerable: false,
        configurable: true
    });
    BlockControls.prototype.render = function () {
        var _this = this;
        var block = this.props.block;
        if (block.$isSavedBlock) {
            return null;
        }
        return (react_1.default.createElement("div", { className: COMPONENT_CLASS },
            react_1.default.createElement(kaleidoscope_1.IconButton, { className: "".concat(COMPONENT_CLASS, "__button"), size: kaleidoscope_1.ButtonSize.Small, disabled: this.isFirstBlock, disabledReason: "Can't move further", icon: react_1.default.createElement(icons_1.ArrowUp, null), tooltip: {
                    content: "Move up",
                    position: kaleidoscope_1.TooltipPosition.Top,
                }, onClick: function () {
                    _this.handleMoveUp();
                } }),
            react_1.default.createElement(kaleidoscope_1.IconButton, { className: "".concat(COMPONENT_CLASS, "__button"), size: kaleidoscope_1.ButtonSize.Small, disabled: this.isLastBlock, disabledReason: "Can't move further", icon: react_1.default.createElement(icons_1.ArrowDown, null), tooltip: {
                    content: "Move down",
                    position: kaleidoscope_1.TooltipPosition.Top,
                }, onClick: function () {
                    _this.handleMoveDown();
                } }),
            react_1.default.createElement(kaleidoscope_1.IconButton, { className: "".concat(COMPONENT_CLASS, "__button"), size: kaleidoscope_1.ButtonSize.Small, disabled: this.isAcceptBlock, disabledReason: "Only 1 Accept Block Allowed", icon: react_1.default.createElement(icons_1.Copy, null), tooltip: {
                    content: "Clone",
                    position: kaleidoscope_1.TooltipPosition.Top,
                }, onClick: function () {
                    _this.handleClone();
                } }),
            react_1.default.createElement(BlockControlsDeletePopover, { onDelete: this.handleDelete })));
    };
    var _a;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof BlockTypes_1.AgreementBlock !== "undefined" && BlockTypes_1.AgreementBlock) === "function" ? _a : Object)
    ], BlockControls.prototype, "agreementBlock", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockControls.prototype, "handleMoveUp", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockControls.prototype, "handleMoveDown", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockControls.prototype, "handleClone", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockControls.prototype, "handleDelete", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], BlockControls.prototype, "isFirstBlock", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], BlockControls.prototype, "isLastBlock", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], BlockControls.prototype, "isAcceptBlock", null);
    BlockControls = __decorate([
        mobx_react_1.observer
    ], BlockControls);
    return BlockControls;
}(react_1.default.Component));
exports.default = BlockControls;
var popoverC = (0, BemBuilder_1.default)("block-control-delete-popover");
var BlockControlsDeletePopover = (function (_super) {
    __extends(BlockControlsDeletePopover, _super);
    function BlockControlsDeletePopover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDeletePopoverOpen = false;
        _this.handleClickDelete = function () {
            _this.isDeletePopoverOpen = false;
            _this.props.onDelete();
        };
        _this.handleClickCancel = function () {
            _this.isDeletePopoverOpen = false;
        };
        _this.handleChangePopover = function (isOpen) {
            _this.isDeletePopoverOpen = isOpen;
        };
        return _this;
    }
    BlockControlsDeletePopover.prototype.render = function () {
        return (react_1.default.createElement(kaleidoscope_1.Popover, { button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({}, buttonProps, { className: "".concat(COMPONENT_CLASS, "__button"), size: kaleidoscope_1.ButtonSize.Small, icon: react_1.default.createElement(icons_1.Delete, null), tooltip: {
                    content: "Delete",
                    position: kaleidoscope_1.TooltipPosition.Top,
                }, buttonState: kaleidoscope_1.ButtonState.Idle }))); }, caret: true, onChange: this.handleChangePopover, isOpen: this.isDeletePopoverOpen, size: kaleidoscope_1.PopoverSize.Small, className: popoverC() },
            react_1.default.createElement("div", { className: popoverC("inner") },
                react_1.default.createElement("div", { className: popoverC("heading") }, "Delete block"),
                react_1.default.createElement("div", { className: popoverC("description") }, "Remove this block permanently from this Qwilr page?"),
                react_1.default.createElement("div", { className: popoverC("buttons") },
                    react_1.default.createElement(kaleidoscope_1.Button, { onClick: this.handleClickCancel, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small }, "Cancel"),
                    react_1.default.createElement(kaleidoscope_1.Button, { onClick: this.handleClickDelete, size: kaleidoscope_1.ButtonSize.Small, isDestructive: true }, "Delete")))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BlockControlsDeletePopover.prototype, "isDeletePopoverOpen", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockControlsDeletePopover.prototype, "handleClickDelete", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockControlsDeletePopover.prototype, "handleClickCancel", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], BlockControlsDeletePopover.prototype, "handleChangePopover", void 0);
    BlockControlsDeletePopover = __decorate([
        mobx_react_1.observer
    ], BlockControlsDeletePopover);
    return BlockControlsDeletePopover;
}(react_1.default.Component));
